<script setup lang="ts">
import { InputBool } from '@/components';
import { useEventCommonStoreRef } from '@/stores';
import type { GPIOReading } from '@/objects/generated';
import { ref, watch } from 'vue';

const updateContestants = defineModel<boolean>('updateContestants', { required: true });

const { GroupsAsSelectLine, CategoriesAsSelectLine } = useEventCommonStoreRef();

const props = defineProps<{
    selectType: 'group' | 'category';
    reading: GPIOReading;
}>();

const groupIds = defineModel<number[]>('groupIds', { required: false });

const flattenGroups = Array.from(GroupsAsSelectLine.value.values());
const groupModel = ref<boolean[]>(flattenGroups.map((group) => props.reading.GroupIDs.includes(group.value as number)));

watch(
    groupModel,
    (newVal) => {
        groupIds.value = newVal
            .map((selected, index) => (selected ? (flattenGroups[index].value as number) : null))
            .filter((id) => id !== null)
            .filter((id) => !props.reading.GroupIDs.includes(id));
    },
    { deep: true },
);

const categoryIds = defineModel<number[]>('categoryIds', { required: false });

const flattenCategories = Array.from(CategoriesAsSelectLine.value.values());
const categoryModel = ref<boolean[]>(flattenCategories.map((category) => props.reading.CategoryIDs.includes(category.value as number)));

watch(
    categoryModel,
    (newVal) => {
        categoryIds.value = newVal
            .map((selected, index) => (selected ? (flattenCategories[index].value as number) : null))
            .filter((id) => id !== null)
            .filter((id) => !props.reading.CategoryIDs.includes(id));
    },
    { deep: true },
);
</script>
<template>
    <div class="p-2">
        <div>
            <InputBool
                v-model="updateContestants"
                :label="'gpioreadings.updatecontestants'"
            ></InputBool>
        </div>
        <div
            v-if="props.selectType === 'group'"
            class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2 overflow-auto"
            style="max-height: 75vh"
        >
            <div
                v-for="(group, index) in GroupsAsSelectLine"
                :key="group[0]?.toString()"
                class="col"
            >
                <InputBool
                    v-model="groupModel[index]"
                    :label="group[1].text"
                    :disabled="reading.GroupIDs.includes(flattenGroups[index].value as number)"
                ></InputBool>
            </div>
        </div>
        <div
            v-else-if="props.selectType === 'category'"
            class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2 overflow-auto"
            style="max-height: 75vh"
        >
            <div
                v-for="(category, index) in CategoriesAsSelectLine"
                :key="category[0]?.toString()"
                class="col"
            >
                <InputBool
                    v-model="categoryModel[index]"
                    :label="category[1].text"
                    :disabled="reading.CategoryIDs.includes(flattenCategories[index].value as number)"
                ></InputBool>
            </div>
        </div>
    </div>
</template>
